/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type DesignLivePreviousDesignersForChatBriefQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type DesignLivePreviousDesignersForChatBriefQuery = {
    __typename: 'Query';
    designLivePreviousDesigners: Array<{
        __typename: 'DesignLiveDesigner';
        acuityCalendarId: number;
        designerName: string;
        designerCanonicalId: string;
    }>;
};

export const DesignLivePreviousDesignersForChatBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'DesignLivePreviousDesignersForChatBrief' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designLivePreviousDesigners' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acuityCalendarId' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerName' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designerCanonicalId' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useDesignLivePreviousDesignersForChatBriefQuery__
 *
 * To run a query within a React component, call `useDesignLivePreviousDesignersForChatBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignLivePreviousDesignersForChatBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignLivePreviousDesignersForChatBriefQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignLivePreviousDesignersForChatBriefQuery(
    baseOptions?: Apollo.QueryHookOptions<
        DesignLivePreviousDesignersForChatBriefQuery,
        DesignLivePreviousDesignersForChatBriefQueryVariables
    >
) {
    return Apollo.useQuery<
        DesignLivePreviousDesignersForChatBriefQuery,
        DesignLivePreviousDesignersForChatBriefQueryVariables
    >(DesignLivePreviousDesignersForChatBriefDocument, baseOptions);
}
export function useDesignLivePreviousDesignersForChatBriefLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        DesignLivePreviousDesignersForChatBriefQuery,
        DesignLivePreviousDesignersForChatBriefQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        DesignLivePreviousDesignersForChatBriefQuery,
        DesignLivePreviousDesignersForChatBriefQueryVariables
    >(DesignLivePreviousDesignersForChatBriefDocument, baseOptions);
}
export type DesignLivePreviousDesignersForChatBriefQueryHookResult = ReturnType<
    typeof useDesignLivePreviousDesignersForChatBriefQuery
>;
export type DesignLivePreviousDesignersForChatBriefLazyQueryHookResult = ReturnType<
    typeof useDesignLivePreviousDesignersForChatBriefLazyQuery
>;
export type DesignLivePreviousDesignersForChatBriefQueryResult = Apollo.QueryResult<
    DesignLivePreviousDesignersForChatBriefQuery,
    DesignLivePreviousDesignersForChatBriefQueryVariables
>;
